export default __webpack_public_path__ + "69cfb277b67a07ef8cfe02d585624aba.svg";